import * as React from 'react';
import * as I18n from 'i18n-js';

interface Props {
  updateSelectedCard: (event: any) => void;
  checked: boolean;
}

export default function AddNewCardButton(props: Props) {
  const {
    updateSelectedCard,
    checked,
  } = props;

  return (
    <li>
      <label
        className="boxed-list__item boxed-list__item--selectable"
        htmlFor="payment_credit_card_id_"
      >
        <input
          type="radio"
          name="payment[credit_card_id]"
          id="payment_credit_card_id_"
          onClick={() => updateSelectedCard('')}
          checked={checked}
          value=""
          className="boxed-list__toggle"
        />
        {I18n.t('discovery.selectableCreditCardList.addNewCard')}
      </label>
    </li>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/add_new_card_button.tsx